export const formatPrice = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return '-';
  }

  return new Intl.NumberFormat('ru-RU', {
    notation: 'standard',
    maximumFractionDigits: 2,
  }).format(value);
};
